<template>
    <div class="home-page">
        <div class="content-container">
            <div class="top">
                <img src="/static/img/banner-get-started-01.png" alt="2tech" class="tech-img-1">
                <img src="/static/img/banner-get-started-02.png" alt="2tech" class="tech-img-2">
                <div class="text-box" :class="{'centerXY spreadXY': $utils.isMobile()}">
                    <div>
                        <div style="font-size: 29px; font-weight: bold" v-if="profile.name">
                            <span class="text-capitalize">{{$t('welcome')}}</span>,
                            {{ profile.name }}
                        </div>
                        <div style="font-size: 29px; font-weight: bold" v-else>
                            <span class="text-capitalize">{{$t('welcomePage.welcome')}}</span>
                        </div>
                        <div class="my-3" style="font-size:20px" v-html="$t('getStartedPage.getStarted')"></div>
                        <v-btn color="#01AFC8" style="color:#fff" large @click="tourConsoleDialog=true">
                            {{$t('explore')}}
                        </v-btn>
                    </div>
                </div>
            </div>
            <div class="bottom">
                <APIList></APIList>
                <ApplicationList></ApplicationList>
            </div>
        </div>
        <v-dialog v-model="tourConsoleDialog" width="774" style="background: #029CB2;" content-class="tour-dialog">
            <v-card style="background: #029CB2;" dark>
                <img src="/static/img/introduction1.png" style="background: #02AFC8; width: 100%"/>
                <v-card-text primary-title>
                    <ConsoleTour ref="tour"></ConsoleTour>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn color="warning" @click="tourConsoleDialog=false">{{$t('gettingStarted')}}</v-btn>
                </v-card-actions>
            </v-card>
            <!--<v-btn fab @click="$refs.tour.back()" class="tour-back">-->
            <!--<v-icon>keyboard_arrow_left</v-icon>-->
            <!--</v-btn>-->
            <!--<v-btn fab @click="$refs.tour.next()" class="tour-next">-->
            <!--<v-icon>keyboard_arrow_right</v-icon>-->
            <!--</v-btn>-->
        </v-dialog>
    </div>
</template>

<script>
    import ConsoleTour from './ConsoleTour'
    import {mapState} from 'vuex'
    import APIList from '@/views/APIs/APIList'
    import ApplicationList from '@/views/Application/ApplicationList'
    import AuthService from '@/services/auth.service'

    export default {
        name: 'Started',
        components: {ConsoleTour, APIList, ApplicationList},
        data() {
            return {
                tourConsoleDialog: false
            }
        },
        computed: {
            ...mapState({
                profile: state => state.user.profile,
                token: state => state.user.token,
                currentProjectId: state => state.user.currentProjectId,
                tourConsoleState: state => state.tourConsole,
                projects: state => state.user.projects
            })
        },
        watch: {
            profile: {
                immediate: true,
                handler(profile) {
                    if (this.tourConsoleState && profile && profile.email) {
                        let projectId = AuthService.getCurrentProjectId(profile.email)
                        if (!projectId) {
                            if (this.$store.state.user.isProjectsLoaded) {
                                if (this.projects.length > 0) {
                                    this.$appService.selectProject().then(
                                        projectId => {
                                            this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, projectId)
                                        }
                                    )
                                } else {
                                    this.tourConsoleDialog = true
                                }
                            }
                        }
                    }
                }
            },
            tourConsoleDialog(newVal) {
                if (!newVal) {
                    this.$store.dispatch(this.$actionTypes.TOUR_CONSOLE, false)
                }
            },
            projects(val) {
                if (this.$store.state.user.isCurrentProjectIdLoaded) {
                    if (this.projects.length > 0) {
                        if (!this.currentProjectId) {
                            this.$appService.selectProject().then(
                                projectId => {
                                    this.$store.dispatch(this.$actionTypes.user.CURRENT_PROJECT_ID, projectId)
                                }
                            )
                        }
                    } else {
                        this.tourConsoleDialog = true
                    }
                }
            }
        }
    }
</script>

<style scoped lang="scss">
    .home-page {
        display: flex;
    }

    .content-container {
        flex: 1 1 100px;
    }

    .top {
        background: #fff;
        height: 210px;
        display: flex;
        align-items: center;
        justify-content: center;
        position: relative;
        overflow: hidden;
    }

    .bottom {
        background: #EDF0F5;
        min-height: calc(100vh - 277px);
    }

    .tech-img-1 {
        position: absolute;
        top: 0;
        left: 0;
    }

    .tech-img-2 {
        position: absolute;
        top: 0;
        right: 0;
    }

    /deep/ .tour-dialog {
        position: relative;
        overflow: visible;
        pointer-events: none;
    }

    .tour-back {
        position: absolute !important;
        top: 50%;
        left: -100px;
    }

    .tour-next {
        position: absolute !important;
        top: 50%;
        right: -100px;
    }

    .text-box {
        z-index: 1;
        background-color: rgba(255, 255, 255, 0.7);
        text-align: center;
    }

    /* Fix display position of icon in button in firefox */
    button i {
        display: inline-flex;
    }
</style>
